import { TooltipModule } from '@usitsdasdesign/dds-ng/tooltip';
import type { Observable } from 'rxjs';

import { Clipboard } from '@angular/cdk/clipboard';
import { AsyncPipe } from '@angular/common';
import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

import { IconsService } from './icons.service';

@Component({
  selector: 'app-icons-page',
  imports: [AsyncPipe, TooltipModule, IconComponent],
  templateUrl: './icons-page.component.html',
  styleUrls: ['./icons-page.component.scss'],
  providers: [IconsService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconsPageComponent implements OnInit {
  private readonly svgIconService = inject(IconsService);
  private readonly clipboard = inject(Clipboard);

  protected searchIconNameString: string;
  protected iconNames$: Observable<string[]>;

  public ngOnInit(): void {
    this.iconNames$ = this.svgIconService.getIconNames();
  }

  protected onIconClick(iconName: string): void {
    this.clipboard.copy(iconName);
    alert('Copied');
  }

  protected onIconSearch(iconName: string): void {
    this.searchIconNameString = iconName;
  }
}
